import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=2f0625b0"
import script from "./newsletter.vue?vue&type=script&lang=js"
export * from "./newsletter.vue?vue&type=script&lang=js"
import style0 from "./newsletter.vue?vue&type=style&index=0&id=2f0625b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports